import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import SortedTablePlugin from "vue-sorted-table"
import Paginate from "@/components/widgets/pagination.vue";
import Customers from "@/components/widgets/customers";
import Loading from "@/components/widgets/Loading.vue"
import moment from "moment";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})
export default {
  components: {
    Customers,
    DatePicker,
    Paginate,
    Loading
  },
  data: function () {
    return {
      sumOfBill: 0,
      sumOfCreditNote: 0,
      // ประเภทใบวางบิล
      //  normal  = วางบิลจากใบส่งสินค้า (เดิม)
      //  dynamic = ตัดใบส่งสินค้าที่มาจากงานล่ำซำออก แล้วใช้ใบรับคำสั่งซื้อล่ำซำแทน
      billingType: 'normal',
      billingTypeOptions: [
        { value: 'normal', text: 'ปกติ — วางบิลจากใบส่งสินค้า' },
        { value: 'dynamic', text: 'งานล่ำซำ — วางบิลจากใบรับคำสั่งซื้อล่ำซำ' }
      ],
      uploadedFiles: [],
      selectedRows: [],
      selectedRows2: [],
      isCustomerPopupOpen: false,
      bank_account_list: [],
      form: {
        document_no: "",
        document_date: "",
        remark: "",
        amount: null,
        bank_account_detail: null,
      },
      loading: false,
      customer: {},
      // ใบมัดจำที่ยังไม่ถูกใช้ ของลูกค้ารายนี้ (ใช้เลือกหักในใบวางบิลล่ำซำ)
      unusedDeposits: [],
      busy: false,
      advanced: false,
      status: null,
      createId: null,
      openedCreate: false,
      sortDesc: false,
      totalItem: 0,
      totalItem2: 0,
      apiStatus: 'ไม่พบข้อมูล',
      doc: {
        start: null,
        end: null
      },
      duedate: {
        start: null,
        end: null
      },
      debtStatus: [
        { text: 'On hold', value: 'onhold' },
        { text: 'ค้างชำระ', value: 'overdue' },
        { text: 'ยกเลิก', value: 'cancel' },
        { text: 'ชำระแล้ว', value: 'success' }
      ],
      perPage: 6,
      sortBy: 'name',
      currentPage: 1,
      currentData: {},
      currentData2: {},
      keyword: "",
      fields: [
        {
          key: 'document_no',
          label: 'เลขที่เอกสาร',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'วันที่เอกสาร',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'bill_duedate',
          label: 'กำหนดชำระ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'bill_customer_name',
          label: 'ชื่อลูกหนี้',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
        },
        {
          key: 'bill_seller',
          label: 'ผู้รับผิดชอบ',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
        },
        {
          key: 'total_price',
          label: 'ยอดชำระทั้งหมด',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true,
          class: 'text-right'
        }
      ],
      fields2: [
        {
          key: 'document_no',
          label: 'เลขที่เอกสาร',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'วันที่เอกสาร',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'document_date',
          label: 'กำหนดชำระคืน',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true
        },
        {
          key: 'delivery_document.customer.company_name',
          label: 'ชื่อลูกค้า',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
        },
        {
          key: 'creator_detail.name',
          label: 'ผู้สร้างเอกสาร',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
        },
        {
          key: 'total',
          label: 'ยอดคืนทั้งหมด',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'text-gray-400 td-top text-xs-1/2',
          sortable: true,
          class: 'text-right'
        }
      ],
      items: [],
      items2: []
    }
  },
  computed: {
    rows() {
      return this.items.length
    },
    isDynamicBilling() {
      return this.billingType === 'dynamic'
    },
    documentSectionTitle() {
      return this.isDynamicBilling
        ? 'ใบรับคำสั่งซื้อล่ำซำที่ยังมียอดคงเหลือ'
        : 'ใบส่งสินค้าที่ค้างชำระทั้งหมด'
    }
  },
  mounted() {
    if(this.$route.params.uuid){
      this.onInitData(this.$route.params.uuid)
    }
    this.onLoadBankAccount()
  },
  methods: {
    handleFileChange(event) {
      this.uploadedFiles = []
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.uploadedFiles.push(files[i]);
      }
    },
    onCustomerSelected(e) {
      this.isCustomerPopupOpen = false;

      if (e.data) {
        this.customer = e.data

        this.loadUnusedDeposits(e.data.id)

        // เปลี่ยนลูกค้า → ล้าง CN ที่เลือกไว้ ไม่งั้นยอดหักค้างข้ามลูกค้า
        this.selectedRows2 = []
        this.sumOfCreditNote = 0

        if(this.$route.params.uuid){
          this.loadUnpaidandCurrentBill(e.data.id, this.$route.params.uuid)
        }
        else{
          this.loadUnpaidBill(e.data.id)
          this.loadCreditNote(e.data.id)
        }
      }
    },
    validateInput(e) {
      let value = e;

      // Allow only digits and one dot (.)
      value = value.replace(/[^0-9.]/g, '');  // Remove anything except numbers and dot

      // Ensure only one dot (.) is allowed
      if (value.indexOf('.') !== value.lastIndexOf('.')) {
        value = value.slice(0, value.lastIndexOf('.'));
      }

      // Update the model value
      this.amount = value;
    },
    onBillingTypeChange(value) {
      // b-form-radio-group ยิง change ก่อนที่ v-model จะอัปเดต → ต้องใช้ค่าจาก event ตรง ๆ
      if (value === 'normal' || value === 'dynamic') {
        this.billingType = value
      }
      // เปลี่ยนประเภทแล้วต้องโหลดรายการใหม่ และล้างที่เลือกไว้
      this.selectedRows = []
      this.sumOfBill = 0
      this.selectedRows2 = []
      this.sumOfCreditNote = 0
      this.form.amount = 0
      this.items = []
      this.totalItem = 0
      if (this.customer && this.customer.id && !this.$route.params.uuid) {
        this.loadUnpaidBill(this.customer.id)
      }
    },
    // แถวบิลล่ำซำ: ยังไม่กางรายการ — กางเมื่อผู้ใช้เลือกใบเท่านั้น (ดู onRowSelected)
    // _showDetails ต้องมีตั้งแต่แรกเพื่อให้ Vue reactive ตอนสลับค่าทีหลัง
    prepareRows(rows) {
      return (rows || []).map(r => r.doc_type === 'bill' ? { ...r, _showDetails: false } : r)
    },
    // ยอดของแถว: ใบส่งสินค้า = ยอดเต็ม, ใบรับคำสั่งซื้อล่ำซำ = ยอดที่เลือกวางในรอบนี้ (bill_amount)
    rowAmount(row) {
      // ใบรับคำสั่งซื้อล่ำซำ: ใช้ "ยอดสุทธิ" หลังส่วนลด/VAT/มัดจำ ของบิลใบนั้น
      if (row.doc_type === 'bill') return this.billCalc(row).net_amount
      return parseFloat(row.total_price || 0)
    },
    recalcSumOfBill() {
      this.sumOfBill = this.selectedRows.reduce((sum, row) => sum + this.rowAmount(row), 0)
      this.form.amount = this.sumOfBill - this.sumOfCreditNote
    },
    // ตาราง "ใบลดหนี้" เรียก @row-selected="onRowSelected2" แต่เดิมไม่มี method นี้
    // → ติ๊กเลือก CN แล้วไม่มีอะไรเกิดขึ้น (เลือกไม่ได้ + ไม่ถูกหักออกจากยอด)
    onRowSelected2(items) {
      this.selectedRows2 = items || []
      // ยอด CN ใช้ field total (ตรงกับที่ API /document/customer-credit-note ส่งมา)
      this.sumOfCreditNote = this.selectedRows2.reduce(
        (sum, row) => sum + (parseFloat(row.total || row.total_price || 0) || 0), 0
      )
      this.recalcSumOfBill()
    },
    onRowSelected(items) {
      this.selectedRows = items
      // กางรายการสินค้าเฉพาะใบที่ถูกเลือก — ใบที่ "เพิ่งถูกยกเลิกเลือก" ปิดรายการ + ล้างการติ๊ก
      // (กันเคสจอโชว์รายการติ๊กอยู่ทั้งที่ใบนั้นไม่ได้ถูกเลือก)
      // ล้างเฉพาะตอนเปลี่ยนจากเลือก→ไม่เลือกเท่านั้น ห้ามล้างใบที่ยังไม่เคยถูกเลือก
      // ไม่งั้นโหมดแก้ไข BN ที่มีหลายบิล พอคลิกใบแรก ติ๊กที่บันทึกไว้ของใบอื่นจะหายหมด
      const picked = new Set((items || []).map(r => r.id))
      const prevPicked = this._prevPickedBillIds || new Set()
      const rows = this.items || []
      rows.forEach((row) => {
        if (row.doc_type !== 'bill') return
        const isPicked = picked.has(row.id)
        if (row._showDetails !== isPicked) this.$set(row, '_showDetails', isPicked)
        if (!isPicked && prevPicked.has(row.id)) {
          const lines = row.products || []
          lines.forEach((line) => {
            if (line.selected) this.$set(line, 'selected', false)
          })
          row.bill_amount = 0
        }
      })
      this._prevPickedBillIds = picked
      this.recalcSumOfBill()
    },
    fmtQty(v) {
      const n = parseFloat(v) || 0
      return n.toLocaleString(undefined, { maximumFractionDigits: 4 })
    },
    fmtMoney(v) {
      const n = parseFloat(v) || 0
      return n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    /**
     * คิดยอดของใบรับคำสั่งซื้อหนึ่งใบในรอบนี้
     * ⚠️ ต้องตรงกับ BillingNoteController::computeBillInvoiceAmounts และ
     *    หน้าใบกำกับเต็มรูป (full-tax/.../calculateTotals) เป๊ะ ๆ
     *    กติกา: มัดจำหักจาก "ยอดก่อน VAT หลังหักส่วนลด"
     * ฐาน VAT ยึดตามบิลต้นทาง (tax_type) ผู้ใช้แก้ไม่ได้ — แก้ได้แค่ส่วนลด/มัดจำ
     */
    billCalc(row) {
      const VAT_RATE = 0.07
      const r2 = (n) => Math.round((parseFloat(n) || 0) * 100) / 100
      const taxType = parseInt(row.tax_type) || 0

      const subTotal = r2((row.products || [])
        .filter(l => l.selected && parseFloat(l.sel_qty) > 0)
        .reduce((sum, l) => sum + (parseFloat(l.sel_amount) || 0), 0))

      const discount = Math.max(r2(row.sel_discount), 0)
      const deposit = Math.max(r2(row.sel_deposit), 0)

      let beforeVat, vat, net
      if (taxType === 2) {
        // รวม VAT: คิดบน gross ตลอด ไม่ปัดระหว่างทาง (มัดจำเป็นฐานก่อน VAT → คูณกลับ)
        const gross = Math.max(subTotal - discount - deposit * (1 + VAT_RATE), 0)
        vat = r2(gross * VAT_RATE / (1 + VAT_RATE))
        beforeVat = r2(gross - vat)
        net = r2(gross)
      } else {
        // แยก VAT (1) / ไม่มี VAT (0): มัดจำหักจาก "ฐานก่อน VAT หลังหักส่วนลด"
        const b1 = r2(Math.max(subTotal - discount, 0))
        const b2 = r2(Math.max(b1 - deposit, 0))
        beforeVat = b2
        vat = taxType === 0 ? 0 : r2(b2 * VAT_RATE)
        net = r2(b2 + vat)
      }

      return { sub_total: subTotal, discount_amt: discount, before_vat: beforeVat, vat_amt: vat, deposit_amt: deposit, net_amount: net }
    },
    /** clamp ค่าเงินให้อยู่ในช่วง 0..max + เด้งช่องกรอกกลับ ถ้าใส่เกิน */
    clampMoneyInput(value, max, inputEl, label) {
      const typed = parseFloat(value)
      let v = typed
      if (isNaN(v) || v < 0) v = 0
      if (v > max) v = max
      v = Math.round(v * 100) / 100

      if (!isNaN(typed) && typed > max) {
        this.$swal({
          icon: 'warning',
          title: `${label}เกินยอดที่ใช้ได้`,
          html: `บิลนี้ใช้${label}ได้ไม่เกิน <b>${this.fmtMoney(max)}</b> บาท<br>ระบบปรับให้เป็นยอดสูงสุดที่ใช้ได้แล้ว`,
          confirmButtonText: 'รับทราบ',
        })
      }
      if (inputEl) inputEl.value = v
      return v
    },
    /**
     * รอบสุดท้ายหรือยัง = ติ๊กวางทุกรายการที่ยังเหลือของบิลนี้จนหมด
     * ถ้าใช่ ส่วนลดคงเหลือต้องถูกใช้ให้หมด ไม่งั้นเก็บเงินลูกค้าเกิน (backend กันอีกชั้น)
     */
    isFinalRoundFor(row) {
      const lines = (row.products || []).filter(l => parseFloat(l.total_price) > 0)
      if (!lines.length) return false
      return lines.every(l => {
        const remaining = parseFloat(l.remaining_qty) || 0
        const use = (l.selected ? parseFloat(l.sel_qty) : 0) || 0
        return remaining - use <= 0.0001
      })
    },
    /** รอบสุดท้าย: มัดจำที่เลือกต้องถูกใช้ให้หมด — เติมให้เต็มอัตโนมัติ (backend บล็อกอีกชั้น)
        เพดานที่รอบนี้รับได้ = ฐานหลังหักส่วนลด (tax 2 มัดจำเป็นฐาน excl จึงหาร 1.07) */
    syncFinalRoundDeposit(row) {
      if (!row.sel_deposit_document_id) return
      if (!this.isFinalRoundFor(row)) return
      const r2 = (n) => Math.round((parseFloat(n) || 0) * 100) / 100
      const c = this.billCalc(row)
      const base = Math.max(c.sub_total - c.discount_amt, 0)
      const cap = parseInt(row.tax_type) === 2 ? r2(base / 1.07) : r2(base)
      const required = Math.min(this.depositRemainingFor(row), cap)
      if ((parseFloat(row.sel_deposit) || 0) < required - 0.009) {
        this.$set(row, 'sel_deposit', required)
      }
    },
    /** ถ้าเข้ารอบสุดท้าย ให้เติมส่วนลดคงเหลือให้เต็มอัตโนมัติ */
    syncFinalRoundDiscount(row) {
      const max = parseFloat(row.max_discount) || 0
      if (max <= 0) return
      if (this.isFinalRoundFor(row)) {
        if ((parseFloat(row.sel_discount) || 0) < max - 0.009) {
          this.$set(row, 'sel_discount', max)
        }
      }
    },
    onBillDiscountInput(row, rowIndex, value, inputEl) {
      const max = parseFloat(row.max_discount) || 0
      const v = this.clampMoneyInput(value, max, inputEl, 'ส่วนลด')
      this.$set(row, 'sel_discount', v)
      this.syncFinalRoundDeposit(row)
      this.recalcSumOfBill()
    },
    /** โหลดใบมัดจำที่ยังไม่ถูกใช้ของลูกค้า (ใช้กับใบวางบิลล่ำซำเท่านั้น) */
    async loadUnusedDeposits(customerId) {
      try {
        const exceptQ = this.$route.params.uuid ? '' : ''
        const res = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/billing_note/unused-deposits/${customerId}${exceptQ}`
        )
        this.unusedDeposits = (res.data && res.data.data) ? res.data.data : []
      } catch (e) {
        this.unusedDeposits = []
      }
    },
    /**
     * ยอดมัดจำที่จะหัก = ยอดก่อน VAT ของใบมัดจำ (excl) เสมอ
     * เพราะสูตรหักมัดจำจากฐานก่อน VAT ตามใบกำกับภาษี
     */
    depositAmountFor(row, dep) {
      if (!dep) return 0
      // มัดจำหักจาก "ยอดก่อน VAT" เสมอ (มิเรอร์ใบกำกับภาษี) — ไม่ขึ้นกับ tax_type ของบิล
      return parseFloat(dep.excl_vat) || 0
    },
    /** ตัวเลือกใบมัดจำของบิลนี้ — รวมใบที่บิลนี้เลือกไว้อยู่แล้ว (โหมดแก้ไข) */
    depositOptionsFor(row) {
      const list = (this.unusedDeposits || []).slice()
      const selId = row.sel_deposit_document_id
      if (selId && !list.some(d => d.id === selId)) {
        list.unshift({
          id: selId,
          document_no: row.sel_deposit_document_no || ('#' + selId),
          excl_vat: row.sel_deposit,
          incl_vat: row.sel_deposit,
        })
      }
      // ใบมัดจำย่อยได้ — ใบเดียวใช้กับหลายบิลในใบวางบิลเดียวกันได้
      // ซ่อนเฉพาะใบที่ "บิลอื่นจองไปจนหมดยอด" แล้วเท่านั้น (ยังเหลือ = ยังเลือกได้)
      // และต้องเป็นประเภท VAT เดียวกับบิล ไม่งั้นฐานภาษีเพี้ยน (backend ก็กันไว้อีกชั้น)
      const billTax = parseInt(row.tax_type) || 0
      return list.filter(d => {
        if (d.id === row.sel_deposit_document_id) return true
        if ((parseInt(d.tax_type) || 0) !== billTax) return false
        const takenByOthers = (this.selectedRows || [])
          .filter(r => r.doc_type === 'bill' && r.id !== row.id && r.sel_deposit_document_id === d.id)
          .reduce((sum, r) => sum + (parseFloat(r.sel_deposit) || 0), 0)
        return this.depositAmountFor(row, d) - takenByOthers > 0.009
      })
    },
    /**
     * ยอดคงเหลือของใบมัดจำที่บิลนี้เลือกอยู่ (ฐานเดียวกับที่บิลใช้หัก)
     * หักยอดที่บิล "ใบอื่น" ในใบวางบิลเดียวกันจองไว้ด้วย — ไม่งั้นรวมกันเกินใบมัดจำ
     */
    depositRemainingFor(row) {
      const id = row.sel_deposit_document_id
      if (!id) return 0
      const dep = (this.unusedDeposits || []).find(d => d.id === id)
      // ใบที่ไม่อยู่ในลิสต์ (โหมดแก้ไข) ใช้ค่าคงเหลือที่ backend ส่งมา
      const base = dep
        ? this.depositAmountFor(row, dep)
        : (parseFloat(row.sel_deposit_remaining) || 0)
      const takenByOthers = (this.selectedRows || [])
        .filter(r => r.doc_type === 'bill' && r.id !== row.id && r.sel_deposit_document_id === id)
        .reduce((sum, r) => sum + (parseFloat(r.sel_deposit) || 0), 0)
      return Math.max(Math.round((base - takenByOthers) * 100) / 100, 0)
    },
    onBillDepositSelect(row, rowIndex, value) {
      const id = parseInt(value) || null
      if (!id) {
        this.$set(row, 'sel_deposit_document_id', null)
        this.$set(row, 'sel_deposit_document_no', null)
        this.$set(row, 'sel_deposit', 0)
      } else {
        const dep = (this.unusedDeposits || []).find(d => d.id === id)
        this.$set(row, 'sel_deposit_document_id', id)
        this.$set(row, 'sel_deposit_document_no', dep ? dep.document_no : row.sel_deposit_document_no)
        this.$set(row, 'sel_deposit', 0)
        // ตั้งต้นหักเต็มยอดคงเหลือ (แก้เป็นบางส่วนได้)
        this.$set(row, 'sel_deposit', this.depositRemainingFor(row))
      }
      this.recalcSumOfBill()
    },
    onBillDepositAmountInput(row, rowIndex, value, inputEl) {
      const max = this.depositRemainingFor(row)
      const v = this.clampMoneyInput(value, max, inputEl, 'ยอดมัดจำ')
      this.$set(row, 'sel_deposit', v)
      // รอบสุดท้ายห้ามหักไม่หมด — ดันกลับเป็นยอดที่ต้องใช้ (แจ้งบน badge แดงหน้าจอ)
      this.syncFinalRoundDeposit(row)
      if (inputEl && parseFloat(row.sel_deposit) !== v) inputEl.value = row.sel_deposit
      this.recalcSumOfBill()
    },
    lineAmount(line, qty) {
      const base = parseFloat(line.base_qty) || 0
      if (base <= 0) return 0
      return Math.round((parseFloat(line.total_price) || 0) * qty / base * 100) / 100
    },
    // ยอดของบิล = รวมรายการสินค้าที่ติ๊กเลือก
    recalcBillRow(row, rowIndex) {
      const lines = row.products || []
      row.bill_amount = Math.round(lines
        .filter(l => l.selected && parseFloat(l.sel_qty) > 0)
        .reduce((sum, l) => sum + (parseFloat(l.sel_amount) || 0), 0) * 100) / 100
      // ไม่สลับการเลือกแถวอัตโนมัติแล้ว — ผู้ใช้เลือกใบเองก่อนถึงจะกางรายการได้
      // (เดิม unselectRow ตอนติ๊กออกหมด ทำให้ใบหลุดเลือกแล้วรายการหุบทันที ติ๊กกลับไม่ได้)
      // วางหมดบิล → เติมส่วนลด/มัดจำคงเหลือให้เต็ม (กันลืมแล้วเก็บเงินเกิน)
      this.syncFinalRoundDiscount(row)
      this.syncFinalRoundDeposit(row)
      this.recalcSumOfBill()
    },
    onLineToggle(row, line, rowIndex, checked) {
      line.selected = !!checked
      // หัวข้อ: ไม่มีจำนวน/ราคา เป็นแค่แถวคั่นกลุ่ม ติ๊กแล้วไม่ต้องเติม qty
      if (line.is_topic) {
        this.$set(line, 'sel_qty', 0)
        this.$set(line, 'sel_amount', 0)
        this.recalcBillRow(row, rowIndex)
        return
      }
      if (line.selected && !(parseFloat(line.sel_qty) > 0)) {
        line.sel_qty = parseFloat(line.remaining_qty) || 0
        line.sel_amount = this.lineAmount(line, line.sel_qty)
      }
      this.recalcBillRow(row, rowIndex)
    },
    onLineQtyInput(row, line, rowIndex, value, inputEl) {
      const max = parseFloat(line.remaining_qty) || 0
      const typed = parseFloat(value)
      let qty = typed
      if (isNaN(qty) || qty < 0) qty = 0
      if (qty > max) qty = max
      qty = Math.round(qty * 10000) / 10000

      // เกินจำนวนคงเหลือ → เด้งกลับเป็นค่าสูงสุดที่วางได้ + เตือนให้รู้ตัว
      const wasClamped = !isNaN(typed) && typed > max
      if (wasClamped) {
        this.$swal({
          icon: 'warning',
          title: 'วางเกินจำนวนคงเหลือ',
          html: `รายการนี้เหลือให้วางบิลได้ <b>${this.fmtQty(max)}</b> ${line.unit_name || ''}<br>ระบบปรับให้เป็นจำนวนสูงสุดที่วางได้แล้ว`,
          confirmButtonText: 'รับทราบ',
        })
      }

      this.$set(line, 'sel_qty', qty)
      this.$set(line, 'sel_amount', this.lineAmount(line, qty))
      this.$set(line, 'selected', qty > 0)

      // บังคับให้ช่องกรอกแสดงค่าที่ถูก clamp แล้วจริง ๆ
      // (ถ้าค่าเดิมเท่ากับ max อยู่แล้ว Vue จะไม่ re-render ช่องนี้ ตัวเลขที่พิมพ์เกินจะค้างบนจอ)
      const el = inputEl || null
      if (el) {
        el.value = qty
      } else {
        this.$nextTick(() => { /* fallback: ให้ binding อัปเดตตามปกติ */ })
      }

      this.recalcBillRow(row, rowIndex)
    },
    onRemove(index) {
      if (index >= 0 && index < this.items.length) {
        this.items.splice(index, 1);
      }
    },
    async onInitData(uuid) {
      try {
        this.loading = true
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const result = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/document/billing_note/${uuid}`)

        this.loading = false
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'

        if (result) {
          const data = result.data
          this.form.document_no = data.document_no
          this.form.document_date = new Date(data.document_date)
          this.form.remark = data.remark
          this.billingType = data.billing_type === 'dynamic' ? 'dynamic' : 'normal'
          const e = {
            status: true,
            data: data.customer,
          }
          this.onCustomerSelected(e)

          // this.currentData = result.data.data
          // this.items = result.data.data
          // this.totalItem = result.data.data.length
        } else {
          this.items = []
          this.totalItem = 0
        }
      } catch (error) {
        this.loading = false
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async onLoadBankAccount() {
      try {
        this.loading = true;
        const res = await this.$axios.get(
          this.$host +
          "/api/v1/document/quotation/branch/bank_accounts/type/0"
        );
        this.bank_account_list = res.data;
        this.loading = false;
      } catch (error) {
        this.loading = false;

        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async loadCreditNote(id) {
      try {
        this.loading = true
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const result = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/document/customer-credit-note/${id}`)

        this.loading = false
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'

        if (result) {
          this.currentData2 = result.data
          this.items2 = result.data
          this.totalItem2 = result.data.length
        } else {
          this.items2 = []
          this.totalItem2 = 0
        }
      } catch (error) {
        this.loading = false
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        // this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async loadUnpaidBill(id) {
      try {
        this.loading = true
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const type = this.billingType
        this.items = []
        this.totalItem = 0
        this.selectedRows = []
        this.recalcSumOfBill()

        const result = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/unPaidInvoices/${id}?type=${type}`)

        this.loading = false
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'

        // กันกรณีสลับประเภทซ้ำเร็ว ๆ แล้ว response เก่ามาถึงทีหลัง
        if (type !== this.billingType) return

        if (result) {
          const rows = this.prepareRows(result.data.data)
          this.currentData = rows
          this.items = rows
          this.totalItem = rows.length
        } else {
          this.items = []
          this.totalItem = 0
        }
      } catch (error) {
        this.loading = false
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.items = []
        this.totalItem = 0
        this.onExceptionHandler(error.response?.data?.message ?? 'โหลดรายการไม่สำเร็จ');
      }
    },
    async loadUnpaidandCurrentBill(id, uuid) {
      try {
        this.loading = true
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const result = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/unPaidandCurrentInvoices/${id}/${uuid}`)

        this.loading = false
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'

        if (result) {
          const deliveryDocuments = result.data.data.delivery_documents
          const billingNote = result.data.data.billing_note
          if (result.data.data.billing_type) {
            this.billingType = result.data.data.billing_type === 'dynamic' ? 'dynamic' : 'normal'
          }

          const merged = this.prepareRows([
            ...deliveryDocuments || [],
            ...(billingNote || [])
          ])

          this.currentData = merged
          this.items = merged
          this.totalItem = merged.length
        } else {
          this.items = []
          this.totalItem = 0
        }
      } catch (error) {
        this.loading = false
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    async requestPayment() {
      if (!this.form.document_date) {
        this.onExceptionHandler('กรุณาเลือกวันกำหนดชำระ');
        return
      }

      if (!this.form.bank_account_detail) {
        this.onExceptionHandler('กรุณาเลือกบัญชีในการชำระเงิน');
        return
      }

      if (this.selectedRows.length === 0) {
        this.onExceptionHandler(this.isDynamicBilling
          ? 'กรุณาเลือกใบรับคำสั่งซื้อล่ำซำที่ต้องการนำไปสร้างใบวางบิล'
          : 'กรุณาเลือกใบส่งสินค้าที่ต้องการนำไปสร้างใบวางบิล');
        return
      }

      const invalidBill = this.selectedRows.find(item =>
        item.doc_type === 'bill' &&
        !(item.products || []).some(l => l.selected && !l.is_topic && parseFloat(l.sel_qty) > 0)
      )
      if (invalidBill) {
        this.onExceptionHandler(`ใบรับคำสั่งซื้อ ${invalidBill.document_no}: กรุณาเลือกรายการสินค้าและระบุจำนวนที่จะวางบิลอย่างน้อย 1 รายการ`);
        return
      }

      try {
        this.loading = true
        this.busy = true

        const formData = new FormData()
        formData.append('remark', this.form.remark ?? '')
        formData.append('amount', this.form.amount ?? '')
        formData.append('bank_account_detail', this.form.bank_account_detail ?? '')
        formData.append('document_date', this.form.document_date ? moment(this.form.document_date).format('YYYY-MM-DD') : null)
        formData.append('customer_id', this.customer.id ?? '')

        formData.append('billing_type', this.billingType)

        // แยกรายการ: ใบส่งสินค้า (items) กับ ใบรับคำสั่งซื้อล่ำซำ (bill_items)
        const ids = this.selectedRows.filter(item => item.doc_type !== 'bill').map(item => item.id);
        formData.append('items', JSON.stringify(ids))

        // ใบรับคำสั่งซื้อล่ำซำ: ส่งรายการสินค้าที่เลือก + จำนวนที่วางในรอบนี้ (backend คำนวณยอดเอง)
        const billItems = this.selectedRows
          .filter(item => item.doc_type === 'bill')
          .map(item => ({
            id: item.id,
            // หัวข้อ qty เป็น 0 เสมอ ต้องส่งไปด้วย (backend บันทึกเป็นแถวคั่นกลุ่ม ยอด 0)
            products: (item.products || [])
              .filter(l => l.selected && (l.is_topic || parseFloat(l.sel_qty) > 0))
              .map(l => ({ id: l.id, qty: l.is_topic ? 0 : parseFloat(l.sel_qty) })),
            // ส่วนลด/มัดจำ ที่ใส่ต่อบิล (VAT ยึดตามบิลต้นทาง backend คิดเอง)
            discount_amt: parseFloat(item.sel_discount) || 0,
            // มัดจำ: ส่ง id ใบมัดจำ + ยอดที่หักรอบนี้ (ย่อยได้) — backend ตรวจไม่ให้เกินคงเหลือ
            deposit_document_id: item.sel_deposit_document_id || null,
            deposit_amt: item.sel_deposit_document_id ? (parseFloat(item.sel_deposit) || 0) : null
          }));
        formData.append('bill_items', JSON.stringify(billItems))

        const ids2 = this.selectedRows2.map(item => item.id);
        formData.append('credit_items', JSON.stringify(ids2))

        const result = await Vue.prototype.$axios.post(`${Vue.prototype.$host}/api/v1/document/billing_note`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })

        this.loading = false
        this.busy = false

        if (result) {
          this.uploadedFiles = []

          alert("สร้างใบวางบิลสำเร็จ");
          this.$router.push('/customerinvoices')
        }
      } catch (error) {
        this.loading = false
        this.busy = false
        this.apiStatus = 'เกิดข้อผิดพลาด'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    }
  }
}